import service from '@/services/SICUDgpd_inf_crd';

export default {
  namespaced: true,

  actions: {
    async update({ dispatch, rootGetters }, event) {
      const rawCreditInfo = event?.stepCreditInfo || {};

      const cleanData = (obj) => Object.entries(obj).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          const lookup = ['crd_mar', 'crd_obse'];

          if (lookup.includes(key) && Array.isArray(value)) {
            acc[key] = value[0].lis_det_par;
          } else {
            acc[key] = value;
          }
        }
        return acc;
      }, {});

      const filteredCreditInfo = cleanData(rawCreditInfo);

      delete filteredCreditInfo.type_credit;

      return new Promise((resolve, reject) => {
        const item = {
          doc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0, // default,
          crd_sec: 1,
          ...filteredCreditInfo,
        };

        const payload = {
          dsSICUDgpd_inf_crd: {
            eeDatos: [rootGetters['auth/state']],
            eegpd_inf_crd: [item],
          },
        };

        let notification;

        service[event?.method || 'post'](payload)
          .then((response) => {
            const data = response.data.dsSICUDgpd_inf_crd;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data.eegpd_inf_crd[0]);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };
              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }
            dispatch('notification/create', notification, { root: true });
            reject(notification);
          });
      });
    },
  },
};
